import { FilterableInterface } from './filterable.interface';

export class Material implements FilterableInterface {
  constructor(
    public hash?: string,
    public fileName?: string,
    public code?: string,
    public amount?: number,
    public planeNumber?: string,
    public denomination?: string,
    public brand?: string,
    public reference?: string,
    public category?: string,
    public subcategory?: string,
    public subcategoryName?: string,
    public printNumber?: string,
    public bluePrintPath?: string,
    public lastUpdate?: number,
    public sequenceNumber?: number,
    public pieceQuantity?: number,
    public quantity?: number,
    public orderNumber?: number,
    public addByHand?: boolean,
    public deliveryDate?: number,
  ) { }

  get filterableData() {
    return `${ this.fileName }`.toLowerCase();
  }

  get name() {
    return this.fileName;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/material.ts